// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"rn-z","badgeLink":"sn-z","category":"tn-z"};